var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{staticClass:"information",attrs:{"adaptive":true,"height":"auto","name":"information"}},[_c('div',[_vm._v("Information")])])}
var staticRenderFns = []

export { render, staticRenderFns }